<mat-form-field>
    <mat-select placeholder="{{ placeholder }}" [formControl]="authInputFormControl" [(ngModel)]="value" (ngModelChange)="sendValue()" (change)="isValid()">
        <mat-option>Selecione uma opção</mat-option>      
        <mat-option *ngFor="let child of children" [value]="child.value">{{ child.title }}</mat-option>
    </mat-select>
    <mat-error [ngClass]="{'auth-error': !isAuth}" *ngIf="authInputFormControl.hasError('required')">
        Campo <strong>obrigatório</strong>
    </mat-error>
</mat-form-field>


// WEBPACK FOOTER //
// /usr/src/app/src/app/components/input-select/input-select.component.html